<script>
import TicketItem from './ticket-item.vue'

export default {
  name: 'TicketList',
  components: { TicketItem },
  data() {
    return {
      filter: {
        current: this.$route.query.current || '1',
      },
      tickets: [],
      loading: false,
      error: null,
    }
  },
  watch: {
    filter: {
      handler() {
        this.pushQuery()
        this.fetchTickets()
      },
      deep: true
    },
  },
  created() {
    this.fetchTickets()
  },
  methods: {
    pushQuery() {
      const q = {}
      if (this.filter.current) q.current = this.filter.current
      try { this.$router.push({ query: q }) } catch(e) { /* noop */ }
    },
    fetchTickets() {
      this.loading = true
      this.error = null

      const params = {}
      if (this.filter.current) params.current = this.filter.current

      this.$api.get('/tickets/', { params })
        .then((res) => {
          if ('results' in res.data) {
            this.tickets = res.data.results
          } else {
            this.tickets = res.data
          }
        })
        .catch((err) => {
          this.error = err.response?.data?.detail || 'Fehler beim Laden der Tickets.'
        })
        .finally(() => { this.loading = false })
    },
  }
}
</script>

<template>
  <div class="container my-3">
    <!-- Filter -->
    <div class="d-flex align-items-center mb-3">
      <div class="form-check form-switch ms-auto">
        <input class="form-check-input" type="checkbox" id="currentSwitch"
               v-model="filter.current" true-value="1" false-value="">
        <label class="form-check-label" for="currentSwitch">Nur aktuelle</label>
      </div>
    </div>

    <!-- Status -->
    <div v-if="loading" class="d-flex justify-content-center my-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Laden…</span>
      </div>
    </div>
    <div v-if="error" class="alert alert-danger">{{ error }}</div>

    <!-- Liste -->
    <div v-if="!loading && tickets.length">
      <TicketItem
        v-for="t in tickets" :key="t.id"
        :ticket="t"
      />
    </div>

    <div v-if="!loading && !tickets.length" class="alert alert-info mt-4">
      Keine Tickets gefunden.
    </div>
  </div>
</template>
